import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  loadingSampleDetails: false,
  sampleDetails: null,
  error: null,
  orderDetails: null,
  dropdowns: {},
};

const sampleReceivedSlice = createSlice({
  name: "sampleReceivedDetails",
  initialState,
  reducers: {
    initializeState(state, action) {
      state.loading = false;
      state.error = null;
      state.orderDetails = null;
    },
    initializeError(state, action) {
      state.error = null;
    },
    fetchOrderDetails(state, action) {
      state.loading = true;
      state.orderDetails = null;
    },
    fetchOrderDetailsSuccess(state, action) {
      state.orderDetails = action.payload.data.document;
      state.loading = false;
    },
    fetchOrderDetailsFailure(state, action) {
      state.loading = false;
    },
    fetchDropdown(state, action) {
      state.fetchingDropdown = true;
    },
    fetchDropdownSuccess(state, action) {
      state.fetchingDropdown = false;
      state.dropdowns = action.payload.data.document;
    },
    fetchDropdownFailure(state, action) {
      state.fetchingDropdown = false;
    },
    saveSampleReceivedDetails(state, action) {
      state.loading = true;
    },
    saveSampleReceivedDetailsSuccess(state, action) {
      state.loading = false;
      state.orderDetails = action.payload.data.document;
    },
    saveSampleReceivedDetailsFailure(state, action) {
      state.loading = false;
      state.error = action.payload.message;
    },
    fetchSampleDetails(state, action) {
      state.loadingSampleDetails = true;
      state.sampleDetails = null;
      state.error = null;
    },
    fetchSampleDetailsSuccess(state, action) {
      state.loadingSampleDetails = false;
      state.sampleDetails = action.payload.data.labSampleReceivedDetails;
    },
    fetchSampleDetailsFailure(state, action) {
      state.loadingSampleDetails = false;
      state.error = action.payload.message;
    },

    saveAcceptanceFormDetails(state, action) {},
    saveAcceptanceFormDetailsSuccess(state, action) {},
    saveAcceptanceFormDetailsFailure(state, action) {},

    saveLabellingFormDetails(state, action) {},
    saveLabellingFormDetailsSuccess(state, action) {},
    saveLabellingFormDetailsFailure(state, action) {},

    moveToUnderTesting(state, action) {},
    moveToUnderTestingSuccess(state, action) {},
    moveToUnderTestingFailure(state, action) {},

    resetState(state, action) {
      state.loading = false;
      state.loadingSampleDetails = false;
      state.sampleDetails = null;
      state.error = null;
      state.orderDetails = null;
      state.dropdowns = {};
    },
  },
});

export const { actions, reducer, name: sliceKey } = sampleReceivedSlice;
